import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import StyledSelect, { type SelectOption } from "./StyledSelect";

export default function MultiSelectField({ label, options, value, onChange, disabled, placeholder, searchPlaceholder }: {
  label: string; options: SelectOption[]; value: string[]; onChange: (ids: string[]) => void;
  disabled?: boolean; placeholder: string; searchPlaceholder: string;
}) {
  const { t } = useTranslation();
  const available = options.filter(option => !value.includes(option.value));
  return <fieldset className="participant-selector span-two">
    <legend>{label}<b className="required"> *</b></legend>
    <StyledSelect label={label} value="" options={available} searchable searchPlaceholder={searchPlaceholder}
      placeholder={placeholder} disabled={disabled || !available.length} emptyMessage={t("No matching records")}
      onChange={id => { if (!value.includes(id)) onChange([...value, id]); }} />
    <ul className="participant-chips" aria-label={label}>
      {value.map(id => {
        const name = options.find(option => option.value === id)?.label || t("Unavailable selection");
        return <li key={id} className="participant-chip"><span>{name}</span>
          <button type="button" aria-label={t("Remove {{name}}", { name })} onClick={() => onChange(value.filter(item => item !== id))}><X size={14} /></button>
        </li>;
      })}
    </ul>
    <small>{t("{{count}} selected", { count: value.length })}</small>
  </fieldset>;
}
